/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { gnoment } from 'shared-ui/gnoment';
import { VisualOnlyLabel } from 'sarsaparilla';
import EntryExitDates from './EntryExitDatesNew';
import { readRuleValue, readRuleMetadata } from '../../utils/utilsNew';
import { MONTH_DAY_YEAR_NUM_FORMAT, SPECIAL_ENTRY_DATE_TEXT } from '../../constants';

export default class PermitTripDates extends React.Component {
    static propTypes = {
        isLottery: PropTypes.bool,
        launchDetail: PropTypes.shape({
            entryDate: PropTypes.shape({}),
        }),
        handleLaunchDetailChange: PropTypes.func,
        handleChangeQuotaDetails: PropTypes.func,
        validation: PropTypes.shape({}),
        permit: PropTypes.shape({}),
        divisionId: PropTypes.string,
        isDisabled: PropTypes.bool,
        stayLimit: PropTypes.shape({}),
        stayMinimum: PropTypes.number,
        isQuotaModifyAllowed: PropTypes.bool,
    };

    static defaultProps = {
        isDisabled: false,
        blockLotteryDates: false,
        extendedStay: false,
        permit: {},
        divisionId: '',
        stayLimit: {},
        stayMinimum: 0,
        isQuotaModifyAllowed: false,
        isBypassRulesValidations: false,
    };

    renderEntry() {
        const entryDate = gnoment(this.props.launchDetail.entryDate).utc(true);
        const specialDateText = readRuleMetadata(
            SPECIAL_ENTRY_DATE_TEXT,
            this.props.permit.rules,
            ''
        );

        return (
            <div className="per-trip-dates-form per-section-group">
                <div className="rec-order-detail-subsection-title">Entry Date</div>
                <p>{specialDateText}</p>
                <div className="rec-form-item-wrap">
                    <VisualOnlyLabel className="rec-sr-only">Entry Date</VisualOnlyLabel>
                    <div id="entryDate" className="per-static-form-item">
                        {entryDate.format(MONTH_DAY_YEAR_NUM_FORMAT)}
                    </div>
                </div>
            </div>
        );
    }

    renderEntryExit() {
        return (
            <EntryExitDates
                isLottery={this.props.isLottery}
                permit={this.props.permit}
                launchDetail={this.props.launchDetail}
                handleLaunchDetailChange={this.props.handleLaunchDetailChange}
                handleChangeQuotaDetails={this.props.handleChangeQuotaDetails}
                validation={this.props.validation}
                divisionId={this.props.divisionId}
                isDisabled={this.props.isDisabled}
                stayLimit={this.props.stayLimit}
                stayMinimum={this.props.stayMinimum}
                isBypassRulesValidations={this.props.isBypassRulesValidations}
                isQuotaModifyAllowed={this.props.isQuotaModifyAllowed}
            />
        );
    }

    render() {
        if (readRuleValue('ShowEntryDateOnly', this.props.permit.rules)) {
            return this.renderEntry();
        }

        return this.renderEntryExit();
    }
}
